export default {
  nav: {
    pricing: 'Pricing',
    faq: 'FAQ',
    dashboard: 'Dashboard',
    login: 'Login',
    logout: 'Logout',
    getAccess: 'Get Access',
  },
  landing: {
    badge: 'Minecraft Utility Mod',
    heroTitle: 'Gain the edge on every server.',
    heroDesc: 'Exusiai is a premium Minecraft utility mod built for anarchy, PvP, and single-player. Powerful modules, clean interface, lifetime access.',
    cta: 'Get Access — $10',
    ctaDashboard: 'Go to Dashboard',
    ctaPurchase: 'Purchase — $10',
    learnMore: 'Learn More',
    features: {
      combat: { title: 'Combat Modules', desc: 'Precision-tuned killaura, criticals, reach, and auto-clicker with fully adjustable settings.' },
      movement: { title: 'Movement Enhancements', desc: 'Sprint, speed, fly, and no-fall modules optimized for anarchy servers and bypass scenarios.' },
      esp: { title: 'Full ESP Suite', desc: 'Player, mob, and item ESP with customizable rendering, tracers, and health indicators.' },
      anti: { title: 'Anti-Detection', desc: 'Built to evade popular anti-cheat plugins. Regularly updated against detection vectors.' },
      hud: { title: 'Custom HUD', desc: 'Modular on-screen display with drag-and-drop widgets, coordinates, FPS, and armor status.' },
      license: { title: 'One-Time License', desc: 'Pay once, own forever. No subscriptions, no recurring fees. HWID-bound for security.' },
    },
    ctaTitle: '$10. One time. Forever.',
    ctaDesc: 'No subscriptions. No hidden fees. Pay once and own Exusiai for life.',
    viewPricing: 'View Pricing',
  },
  pricing: {
    title: 'Simple Pricing',
    subtitle: 'One purchase. Lifetime access.',
    planName: 'Lifetime License',
    planDesc: 'All current and future modules',
    price: '$10',
    currency: 'USD',
    oneTime: 'One-time payment · No recurring charges',
    features: {
      f1: 'All combat, movement & ESP modules',
      f2: 'Customizable HUD and keybinds',
      f3: 'HWID-bound license (2 resets/month)',
      f4: 'Free updates for life',
      f5: 'Priority anti-cheat compatibility updates',
    },
    purchase: 'Purchase with Stripe',
    createAccount: 'Create Account to Purchase',
    termsNotice: 'By purchasing you agree to our',
    terms: 'Terms',
    noRefunds: 'No refunds.',
  },
  auth: {
    welcomeBack: 'Welcome back',
    signInDesc: 'Sign in to your Exusiai account',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    signingIn: 'Signing in...',
    signIn: 'Sign in',
    dontHaveAccount: "Don't have an account?",
    createOne: 'Create one',
    createAccount: 'Create account',
    joinExusiai: 'Get access to Exusiai for $10',
    passwordPlaceholder: 'At least 8 characters',
    creating: 'Creating account...',
    alreadyHaveAccount: 'Already have an account?',
    passwordMinLength: 'Password must be at least 8 characters',
    completeVerification: 'Please complete the verification',
    invalidEmailPassword: 'Invalid email or password',
    emailExists: 'Email already registered',
    resetPassword: 'Reset password',
    resetDesc: 'Enter your email to receive a reset link',
    sending: 'Sending...',
    sendResetLink: 'Send reset link',
    backToLogin: 'Back to login',
    checkEmail: 'Check your email',
    emailSent: 'If an account exists for {{email}}, a reset link has been sent.',
    newPassword: 'New password',
    newPasswordDesc: 'Set a new password for your account',
    updating: 'Updating...',
    updatePassword: 'Update password',
  },
  dashboard: {
    title: 'Dashboard',
    loading: 'Loading...',
    notSignedIn: 'Not signed in',
    notSignedInDesc: 'Sign in to access your dashboard.',
    goToLogin: 'Go to login',
    noLicense: 'No license yet',
    noLicenseDesc: 'Purchase Exusiai for $10 to get lifetime access.',
    purchase: 'Purchase — $10',
    licenseStatus: 'License Status',
    licenseId: 'License ID',
    hwidBound: 'HWID Bound',
    yes: 'Yes',
    notActivated: 'Not activated',
    resetsThisMonth: 'Resets This Month',
    purchased: 'Purchased',
    download: 'Download',
    downloadDesc: 'Download the Exusiai loader. Run it on your machine and log in with your account to activate.',
    downloadLoader: 'Download Loader',
    preparing: 'Preparing...',
    hwidReset: 'HWID Reset',
    hwidResetDesc: 'Reset your hardware binding if you changed devices. Limited to {{max}} per month.',
    resetHwid: 'Reset HWID',
    resetting: 'Resetting...',
    resetSuccess: 'HWID reset successful. You can now activate on a new device.',
    resetConfirm: 'Reset HWID binding? This will unbind your current device. You can activate on a new device afterwards.',
  },
  checkout: {
    success: 'Payment successful',
    successDesc: 'Your license is now active. A receipt has been sent to your email.',
    goToDashboard: 'Go to Dashboard',
    cancelled: 'Payment cancelled',
    cancelledDesc: 'No charge was made. You can try again anytime.',
    backToPricing: 'Back to Pricing',
  },
  faq: {
    title: 'Frequently Asked Questions',
    items: {
      q1: 'What is Exusiai?',
      a1: 'Exusiai is a premium Minecraft utility mod that provides combat, movement, and visual modules designed for anarchy and PvP servers, as well as single-player worlds.',
      q2: 'How much does it cost?',
      a2: 'Exusiai costs $10 USD as a one-time purchase. There are no subscriptions or recurring fees. You own the license for life.',
      q3: 'How do I activate my license?',
      a3: 'After purchasing, download the loader from your dashboard. Log in with your account inside the loader. Your license is bound to your hardware (HWID) on first activation.',
      q4: 'What is HWID binding?',
      a4: "Your license is tied to your computer's hardware signature (disk, CPU, and GPU serial numbers). This prevents account sharing. You can reset your HWID up to 2 times per month from your dashboard.",
      q5: 'What happens if I upgrade my PC?',
      a5: 'You can reset your HWID binding from the dashboard. Each month you get 2 free resets. If you need more, contact support.',
      q6: 'Do you offer refunds?',
      a6: 'No. All sales are final. We recommend reviewing the features and FAQ carefully before purchasing.',
      q7: 'What Minecraft version is supported?',
      a7: 'Exusiai targets Minecraft Java Edition. Check the changelog for the latest supported versions.',
      q8: 'Is it detectable by anti-cheat?',
      a8: 'Exusiai is regularly updated to maintain compatibility with popular anti-cheat systems, but no cheat is ever 100% undetectable. Use on servers at your own discretion.',
      q9: 'Can I get banned?',
      a9: 'Yes. Using utility mods on servers that prohibit them can result in a ban. Exusiai is designed for servers that tolerate such modifications, or for single-player use.',
    },
  },
  footer: {
    tagline: 'Premium Minecraft utility mod for anarchy, PvP, and single-player.',
    product: 'Product',
    legal: 'Legal',
    terms: 'Terms',
    privacy: 'Privacy',
    rights: 'All rights reserved.',
  },
  admin: {
    title: 'Admin Panel',
    enterKey: 'Enter admin key to access',
    unlock: 'Unlock',
    invalidKey: 'Invalid admin key',
    currentLoader: 'Current Loader',
    noLoader: 'No loader uploaded yet.',
    file: 'File',
    size: 'Size',
    version: 'Version',
    uploaded: 'Uploaded',
    deleteLoader: 'Delete Loader',
    uploadNew: 'Upload New Loader',
    loaderFile: 'Loader file (.exe)',
    versionLabel: 'Version (optional)',
    versionPlaceholder: 'e.g. 1.0.0',
    uploadLoader: 'Upload Loader',
    uploading: 'Uploading...',
    selectFile: 'Please select a file',
    deleteConfirm: 'Delete the current loader? Users will not be able to download.',
    deleted: 'Loader deleted',
  },
};
